export default "__VITE_ASSET__Fa0c1AzE__"